import { useState } from "react";
import { COMPANY } from "@/data/content";

const buildWhatsAppUrl = (message) => {
  const num = COMPANY.whatsapp.number;
  const msg = encodeURIComponent(message || COMPANY.whatsapp.default_message);
  return `https://wa.me/${num}?text=${msg}`;
};

export const WhatsAppFab = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-24 right-6 z-[60] flex flex-col items-end gap-3">
      {open && (
        <div
          data-testid="whatsapp-popover"
          className="w-72 bg-white border border-stone-200 shadow-xl overflow-hidden animate-in fade-in slide-in-from-bottom-2 duration-300"
        >
          <div className="bg-[#075E54] text-white px-5 py-4">
            <div className="text-xs uppercase tracking-[0.2em] opacity-80">Chat on WhatsApp</div>
            <div className="font-display text-lg leading-tight mt-1">We typically reply in minutes</div>
          </div>
          <div className="p-5 bg-[#ECE5DD]">
            <div className="bg-white shadow-sm p-3 max-w-[85%] relative">
              <div className="text-xs text-[#075E54] font-medium mb-1">ITHR Technologies</div>
              <div className="text-sm text-stone-800 leading-relaxed">
                Hi — how can our team help you today?
              </div>
              <div className="text-[10px] text-stone-400 text-right mt-1">just now</div>
            </div>
          </div>
          <div className="p-4 bg-white border-t border-stone-200 flex items-center gap-2">
            <a
              data-testid="whatsapp-popover-cta"
              href={buildWhatsAppUrl()}
              target="_blank"
              rel="noreferrer"
              className="flex-1 inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white font-medium py-2.5 text-sm transition-colors"
            >
              <WhatsAppIcon className="w-4 h-4" />
              Start chat
            </a>
            <button
              data-testid="whatsapp-popover-close"
              onClick={() => setOpen(false)}
              className="px-3 py-2.5 text-stone-600 hover:text-stone-900 text-sm"
              aria-label="Close"
            >
              Close
            </button>
          </div>
        </div>
      )}

      <button
        data-testid="whatsapp-fab"
        onClick={() => setOpen((v) => !v)}
        aria-label="Open WhatsApp chat"
        className="relative w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1DA851] text-white shadow-[0_8px_24px_-4px_rgba(37,211,102,0.5)] flex items-center justify-center transition-all hover:scale-105 active:scale-95"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <WhatsAppIcon className="w-7 h-7 relative" />
      </button>
    </div>
  );
};

export const WhatsAppIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.05 4.91A10 10 0 0 0 2.05 16.04L1 22l6.13-1.6a10 10 0 0 0 4.79 1.22h.01c5.52 0 10-4.48 10-10a9.94 9.94 0 0 0-2.88-7.05Zm-7.12 15.35h-.01a8.3 8.3 0 0 1-4.23-1.16l-.3-.18-3.64.95.97-3.55-.2-.31a8.3 8.3 0 1 1 15.36-4.4 8.3 8.3 0 0 1-7.95 8.65Zm4.54-6.21c-.25-.13-1.47-.73-1.7-.81-.23-.08-.4-.13-.56.13-.17.25-.65.81-.79.97-.15.17-.3.19-.55.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.48-1.39-1.73-.15-.25-.02-.39.1-.51.11-.11.25-.3.37-.45.12-.15.16-.25.24-.42.08-.17.04-.31-.02-.44-.06-.12-.55-1.34-.76-1.84-.2-.48-.41-.42-.55-.43-.14 0-.31-.02-.47-.02a.9.9 0 0 0-.65.31c-.22.25-.85.83-.85 2.02 0 1.19.87 2.34.99 2.51.12.17 1.71 2.61 4.15 3.66.58.25 1.03.4 1.38.51.58.18 1.1.15 1.51.09.46-.07 1.42-.58 1.62-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.47-.29Z" />
  </svg>
);

export const whatsAppHref = buildWhatsAppUrl;

export default WhatsAppFab;
